import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from "react-redux"
import { useForm } from 'react-hook-form';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Add from '@mui/icons-material/Add';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';

import swal from 'sweetalert';
import Loading from '../Loading/Loader';

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import {
    selectAllEstudiosNiveles,
    fetchEstudiosNiveles,
    getUtilityIsLoading
} from './../../../redux/Utility/UtilitySlice'

import { 
    addNewEmpleadoEstudios,
    selectEmpleadosIsLoading,
    selectEmpleadosIsSuccess,
    selectEmpleadosMessage 
} from '../../../redux/Empleados/EmpleadosSlice';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	border: '2px solid #000',
	boxShadow: 24,
	pt: 2,
	px: 4,
	pb: 3
};

const EstudiosNuevos = ({openEstudiosNuevo, setOpenEstudiosNuevo, empleadoId}) => {

    // * ESTRUCTURA DEL FORM.
    const formSchema = Yup.object().shape({
        estudios: Yup.object().shape({
            estudioNivelId: Yup.number().required("El campo es requerido").notOneOf([0], "Debe seleccionar una categoría válida"),
            empleadoId: Yup.number().required("El campo es requerido"),
            titulo: Yup.string().required("El campo es requerido"),
            fecha: Yup.date().required("El campo es requerido"),
            institucionAcademica: Yup.string().required("El campo es requerido"),
            estado: Yup.string().required("El campo es requerido"),
        }),
    });

    // ? HOOK-FORM
    const {
        register,
        handleSubmit, 
        formState:{errors},
        control,
        reset 
    } = useForm(
        {
            resolver: yupResolver(formSchema),
            defaultValues: {
                estudios: {
                    estudioNivelId: 0,
                    empleadoId: 0,
                    titulo: '',
                    estado: '',
                    fecha: new Date(),
                    institucionAcademica: ''
                }

            }
        }
    );

    // ? HOOK-DISPATCH
    const dispatch = useDispatch();

    // ? HOOK-SELECTOR
    const estudiosNiveles = useSelector(selectAllEstudiosNiveles);
    const isLoading = useSelector(getUtilityIsLoading);
    const isSuccess = useSelector(selectEmpleadosIsSuccess);
    const isLoadingEmpleado = useSelector(selectEmpleadosIsLoading)
    const empleaodMessage = useSelector(selectEmpleadosMessage)

    // ? HOOK-STATE
    const [openLoading,setOpenLoading] = useState(false);

    // * FUNCIONES
    const onSubmit = ({ estudios }) => {

        // * ASIGNACION DE DATA
        const data = estudios;
        data.empleadoId = empleadoId;

        dispatch(addNewEmpleadoEstudios(data));
    }
    const handleClose=()=>{
        setOpenEstudiosNuevo(false);
    }

    // ? HOOK-EFFECT
    useEffect(()=>{
        dispatch(fetchEstudiosNiveles());
    },[])

    useEffect(()=>{

        if(isSuccess==='success' && empleaodMessage.length > 0){
			swal("Exitoso!", "Fue agregado el dependiente", "success");
            handleClose();
            reset();
		}else if(isSuccess==='error'&& empleaodMessage.length > 0){
			swal("Error!", empleaodMessage, "error");
		}
        
    },[isSuccess])

    useEffect(()=>{
        if(!isLoading && !isLoadingEmpleado)
        {
            setOpenLoading(false)
        }else{
            setOpenLoading(true)
        }

    },[isLoading, isLoadingEmpleado])

  return (
    <Modal
    open={openEstudiosNuevo}
    onClose={handleClose}
    aria-labelledby="parent-modal-title"
    aria-describedby="parent-modal-description"
>
    <Box sx={{ ...style, width: 700 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
        <div className="container">
            <div className="row">
                <h3 className="text-primary-mem text-center">Estudios</h3>
            </div>
            <div className="row">
                <div className="col-5 me-0 pe-0">
                    <hr />
                </div>
                <div className="col-2 text-center">
                <Add className='text-primary-mem'></Add>
                </div>
                <div className="col-5 ms-0 ps-0 ">
                    <hr />
                </div>
            </div>
            <div className='row'>
                <div  hidden>
                    <input {...register("estudios.empleadoId")}></input>
                </div>
                <div className='form-group'>
                    <label className='fw-bold'>Nivel</label>
                    <select {...register("estudios.estudioNivelId")} className='form-control'>
                        <option value={0}>Seleccionar nivel</option>
                        {
                            estudiosNiveles && estudiosNiveles.length>0 &&(
                                estudiosNiveles.map(nivel => <option key={nivel.id} value={Number(nivel.id)}>{nivel.nombre}</option>)
                            )                        
                        }
                       
                    </select>
                    <p className='text-danger'>{errors?.estudios?.estudioNivelId?.message}</p>
                </div>
                <div className='form-group'>
                    <label className='fw-bold'>Titulo Obtenido</label>
                   <input type="text" {...register("estudios.titulo")} className="form-control"></input>
                   <p className='text-danger'>{errors?.estudios?.titulo?.message}</p>
                </div>
                <div className='form-group'>
                    <label className='fw-bold'>Estado</label>
                    <select {...register("estudios.estado")} className='form-control'>
                        <option value="">Seleccionar estado</option>
                        <option value="En curso">En curso</option>
                        <option value="Terminado">Terminado</option>
                       
                    </select>
                    <p className='text-danger'>{errors?.estudios?.estado?.message}</p>
                </div>
                <div className="form-group">
                    <label className="fw-bold">Fecha de Obtención</label>
                    <Controller
                        control={control}
                        className="mb-3"
                        name="estudios.fecha"
                        render={({ field }) => (
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    inputFormat='dd/MM/yyyy'
                                    label={' '}
                                    mask="__/__/____"
                                    value={field.value}
                                    onChange={(e) => field.onChange(e)}
                                    renderInput={(params) => (
                                        <TextField
                                            height={10}
                                            className="form-control"
                                            style={{ height: 10 }}
                                            {...params}
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        )}
                    />
                    <p className='text-danger mt-3'>{errors?.estudios?.fecha?.message}</p>
				</div>
                <div className='form-group'>
                    <label className='fw-bold'>Institución Académica</label>
                   <input type="text" {...register("estudios.institucionAcademica")} className="form-control"></input>
                   <p className='text-danger'>{errors?.estudios?.institucionAcademica?.message}</p>
                </div>
                <div className='d-flex justify-content-center'>
                <button type='submit' className='btn btn-primary-mem me-3' id='btn-guardar'>Guardar</button>
                <button type='button' className='btn btn-danger ' onClick={handleClose} id='btn-cancelar'>Cancelar</button>
                </div>
            </div>
        </div>
        </form>
        <Loading open={openLoading}></Loading>
    </Box>
   
</Modal>
  )
}

export default EstudiosNuevos